import { useQuery } from 'react-query';

import { Menu } from '../../type';
import { axios } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

export const getAllMenu = async (): Promise<Menu[]> => {
    const { data } = await axios.get(`v1/admin/menus/get-menu-groups`);
    return data;
};

type QueryFnType = typeof getAllMenu;

type UseCorpsOptions = {
    config?: QueryConfig<QueryFnType>;
};

export const useMenu = ({ config }: UseCorpsOptions = {}) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['menu'],
        queryFn: () => getAllMenu(),
    });
};
